












































































import { OvertimeRequestStateEnum } from '@/models';
import auth from '@/mixins/auth';
import mixins from '@/utils/mixins';
import { IFetchOvertimeRequestsFilterParams } from '@/store/overtime-request';

export default mixins(auth).extend({
  name: 'OvertimeRequestSerachFilter',

  props: {
    open: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      filterParams: {} as IFetchOvertimeRequestsFilterParams,

      stateList: [
        {
          value: OvertimeRequestStateEnum.Submitted,
          display_name: 'Submitted'
        },

        {
          value: OvertimeRequestStateEnum.Approved,
          display_name: 'Approved'
        },

        {
          value: OvertimeRequestStateEnum.Cancelled,
          display_name: 'Cancelled'
        },

        {
          value: OvertimeRequestStateEnum.Rejected,
          display_name: 'Rejected'
        }
      ]
    };
  },

  computed: {
    openValue: {
      get(): boolean {
        return this.open;
      },
      set(val: boolean) {
        if (val === this.open) return;
        this.$emit('update:open', val);
      }
    }
  },

  methods: {
    closeSearchFilterDialog() {
      this.openValue = false;

      // reset filter params back to empty object
      this.resetFilterParams();
    },

    resetFilterParams() {
      this.filterParams = {};
    },

    openSearchFilterDialog(params: IFetchOvertimeRequestsFilterParams) {
      if (params.state != null && !isNaN(params.state)) {
        this.filterParams.state = Number(params.state);
      }

      this.openValue = true;
    },

    save() {
      this.$emit('change', this.filterParams);
      this.closeSearchFilterDialog();
    }
  }
});
